import React from 'react';

import { cn } from '@column/ui';

interface TransferAmountProps extends React.ComponentProps<'span'> {
  $isAdding?: boolean;
}

export const TransferAmount: React.FC<TransferAmountProps> = ({ $isAdding, className, children, ...props }) => (
  <span
    className={cn(
      'relative flex items-baseline gap-1 text-sm font-medium leading-[14px] tracking-normal',
      $isAdding === true && 'text-green-600 dark:text-green-600',
      $isAdding !== true && 'text-foreground',
      className
    )}
    {...props}
  >
    {$isAdding === false && (
      <span className="absolute right-full top-[-1px] z-10 [font:inherit] [line-height:inherit]">-</span>
    )}
    {children}
  </span>
);
